/**
 * OrbDocCoreConceptsPatternsENOrbDocCoreConceptsPatternsENPage
 *
 * Page component for OrbDocCoreConceptsPatternsENOrbDocCoreConceptsPatternsENPage
 * Path: /docs/core-concepts/patterns
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { OrbDocCoreConceptsPatternsENDocScreenView as __OrbDocCoreConceptsPatternsENDocScreenView } from '@/components/traits/OrbDocCoreConceptsPatternsENDocScreenView';
import { OrbDocCoreConceptsPatternsENDocAnalyticsView as __OrbDocCoreConceptsPatternsENDocAnalyticsView } from '@/components/traits/OrbDocCoreConceptsPatternsENDocAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';
import { usePageHead } from '@almadar/ui/hooks';

interface OrbDocCoreConceptsPatternsENOrbDocCoreConceptsPatternsENPageProps {
  // Add any page-level props here
}

export function OrbDocCoreConceptsPatternsENOrbDocCoreConceptsPatternsENPage(_props: OrbDocCoreConceptsPatternsENOrbDocCoreConceptsPatternsENPageProps) {
  const __location = useLocation();
  const __navState = (__location.state ?? {}) as EventPayload;

  usePageHead({ "title":"UI patterns","description":"What render-ui can draw: a tree of registered patterns, bound to the entity.","access":"public","indexing":"index","origin":"https://orb.almadar.io","siteName":"Orb","alternates":[{"locale":"en","path":"/docs/core-concepts/patterns"},{"locale":"ar","path":"/ar/docs/core-concepts/patterns"},{"locale":"sl","path":"/sl/docs/core-concepts/patterns"}],"defaultLocale":"en", path: __location.pathname });

  return (
    <>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__OrbDocCoreConceptsPatternsENDocScreenView config={{ initPayload: __navState }} />
          <__OrbDocCoreConceptsPatternsENDocAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </>
  );
}

export default OrbDocCoreConceptsPatternsENOrbDocCoreConceptsPatternsENPage;
